import { render, staticRenderFns } from "./PurchaseAgingEstimation.vue?vue&type=template&id=5ba5ea16"
import script from "./PurchaseAgingEstimation.vue?vue&type=script&lang=js"
export * from "./PurchaseAgingEstimation.vue?vue&type=script&lang=js"
import style0 from "./PurchaseAgingEstimation.vue?vue&type=style&index=0&id=5ba5ea16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports